import { useEffect, useRef } from "react";
import { useAuth } from "@/shared/auth/useAuth";
import { registerSessionExpiredHandler } from "@/shared/auth/authSession";
import { resolveAuthRealm } from "@/shared/auth/authRealm";
import {
  getJwtExpiryEpochSeconds,
  TOKEN_REFRESH_BUFFER_SECONDS,
} from "@/shared/auth/cognito";
import { ensureValidBearerToken } from "@/shared/auth/ensureValidBearerToken";
import { useCognitoSignOut } from "@/shared/auth/useCognitoSignOut";

export function AuthSessionWatcher() {
  const { idToken, isAuthenticated } = useAuth();
  const realm = resolveAuthRealm();
  const signOut = useCognitoSignOut();
  const signOutRef = useRef(signOut);
  signOutRef.current = signOut;

  useEffect(() => {
    registerSessionExpiredHandler(() => signOutRef.current());
    return () => registerSessionExpiredHandler(null);
  }, []);

  useEffect(() => {
    if (!isAuthenticated || !idToken) {
      return;
    }

    const exp = getJwtExpiryEpochSeconds(idToken);
    if (exp === null) {
      void ensureValidBearerToken(realm);
      return;
    }

    const refreshAtMs =
      (exp - TOKEN_REFRESH_BUFFER_SECONDS) * 1000 - Date.now();
    const timeoutId = window.setTimeout(
      () => void ensureValidBearerToken(realm),
      Math.max(0, refreshAtMs),
    );
    return () => window.clearTimeout(timeoutId);
  }, [idToken, isAuthenticated, realm]);

  return null;
}
